import React, {useEffect} from 'react';
import logo from '@assets/images/logo.png';
import {Link} from 'react-router-dom';

const PageError = () => {
  useEffect(() => {
    const bodyEl = document.querySelector("body");
    if(bodyEl) {
      bodyEl.classList.add("body-tertiary");
    }

    return () => {
      if(bodyEl) {
        bodyEl.classList.remove("body-tertiary");
      }
    };
  }, []);
  return (
    <main>
      <div className="container h-100">
        <div className="row h-100 section-message">
          <div className="col-sm-12 mx-auto my-auto">
            <div className="text-center section-logo">
              <Link to="/"><img src={logo} alt="logo" /></Link>
            </div>
            <div className="page-error pb-5">Server error, please try later.</div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default PageError;
